import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Securitee > Local accounts (`SecuriteeLocalAccountsController`): conturile
 * locale ale masinilor Windows, citite de agent. `unused`, `builtinEnabled` si
 * `neverExpires` sunt regulile cardurilor (`LocalAccountRules`), calculate pe server.
 */

export type LocalAccountRow = {
  deviceId: number
  machine: string
  name: string
  enabled: boolean
  builtin: 'administrator' | 'guest' | 'system' | null
  /** ora serverului; null = niciodata */
  lastLogon: string | null
  neverExpires: boolean
  passwordAgeDays: number
  unused: boolean
  builtinEnabled: boolean
}

export type LocalAccountsOverview = {
  /** tabela exista pe instalarea asta */
  ready: boolean
  counts: { accounts: number; enabled: number; unused: number; builtin: number; neverExpires: number }
  rows: LocalAccountRow[]
}

export function localAccountsQuery() {
  return queryOptions({
    queryKey: ['securitee', 'local-accounts'],
    queryFn: () => apiGet<LocalAccountsOverview>('/securitee/local-accounts'),
  })
}
